import PropTypes from 'prop-types'
import React from 'react'
import { cn } from '../modules'
import InstagramLogo from '../icons/InstagramLogo'

function NewsListItemSocial({
  source,
  image,
  excerpt,
  active,
}) {
  switch (source) {
    case 'instagram':
      return (
        <div
          className={cn(
            'relative w-full h-full aspect-square rounded-lg text-white',
            '[a_&]:active:ring-2 [a_&]:active:ring-offset-2 [a_&]:active:ring-theme-500',
            '[button_&]:active:ring-2 [button_&]:active:ring-offset-2 [button_&]:active:ring-theme-500',
            active && 'ring-2 ring-offset-2 ring-theme-500',
            !image && 'bg-gray-50 text-black',
          )}
        >
          <div className="absolute top-3 right-3 z-10">
            <InstagramLogo className="absolute top-1 right-1 h-6 w-6" />
            <div
              className={cn(
                'absolute top-0 right-0 w-8 h-8 bg-white opacity-20 rounded-full',
                !image && 'bg-black',
              )}
            />
          </div>
          <div className="relative w-full h-full">
            {image && (
              <img
                className="absolute w-full h-full bg-center object-cover rounded-lg bg-gray-50 overflow-hidden"
                src={image}
                alt={excerpt}
              />
            )}
            <div
              className={cn(
                'absolute w-full h-full rounded-lg [button_&]:hover:bg-black/50 [button_&]:active:bg-black/50',
                '[a_&]:hover:bg-black/50 [a_&]:active:bg-black/50',
                active && 'bg-black/50',
              )}
            />
          </div>
        </div>
      )
    default:
      return null
  }
}

NewsListItemSocial.propTypes = {
  source: PropTypes.string.isRequired,
  image: PropTypes.string,
  excerpt: PropTypes.string,
  active: PropTypes.bool,
}

NewsListItemSocial.defaultProps = {
  image: null,
  excerpt: null,
  active: false,
}

export default NewsListItemSocial
